import { Divider, Stack } from '@mui/material';
import { BuildOutlined, SecurityOutlined, TextIncrease } from '@mui/icons-material';
import { useTheme } from '../../../styles';
import { CubeIcon, ListItemContainer, ListItemContent, ListItemProps } from './ListItem';

export const ModelListItem: React.FC<ListItemProps> = (props) => {
  const theme = useTheme();

  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key} {...liProps}>
      <CubeIcon color={option?.metadata?.color} />
      <ListItemContent>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <h1>{option.label}</h1>
          <Stack mt={0.5} direction='row' spacing={1.5} divider={<Divider flexItem orientation='vertical' />}>
            {option?.metadata?.json && (
              <Stack spacing={0.75} direction='row' alignItems='center'>
                <p id='smallNoWrap'>JSON</p>
              </Stack>
            )}
            {option?.metadata?.tier && (
              <Stack spacing={1} direction='row' alignItems='center'>
                <TextIncrease sx={{ fontSize: '13px' }} />
                <p id='smallNoWrap'>{option?.metadata?.tier}</p>
              </Stack>
            )}
            {option?.metadata?.tools && (
              <Stack spacing={0.75} direction='row' alignItems='center'>
                <BuildOutlined sx={{ fontSize: '13px' }} />
              </Stack>
            )}
            {option?.metadata?.paid && (
              <Stack spacing={0.75} direction='row' alignItems='center'>
                <SecurityOutlined sx={{ fontSize: '13px', color: `${theme.primary} !important` }} />
              </Stack>
            )}
            {option?.metadata?.node_id && (
              <Stack spacing={0.75} direction='row' alignItems='center'>
                <p id='smallNoWrap'>Node: #{option?.metadata?.node_id}</p>
              </Stack>
            )}
          </Stack>
        </Stack>
      </ListItemContent>
    </ListItemContainer>
  );
};
